import { Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import React from 'react';
import { SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import ValueInput from '../../ValueInput';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Form from 'react-bootstrap/esm/Form';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Path detail component (length & sites)
 */
export default class AdditionalLosses extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);
    }

    render() {
        return (
            <>
                { this.props.band == 1 ?
                    <SingleBandLinkUserContext.Consumer>
                    {(link) => (
                        <Row>
                            <Col xs={6}>
                                <Form.Label>Site 1 additional loss</Form.Label>
                                <ValueInput valueType="float" value={link.losses_site1 != null ? link.losses_site1 : 0}
                                    onChange={(data: any) => {
                                        data = parseFloat(data);
                                        if(!Number.isNaN(data)) {
                                            link.define("losses_site1", parseFloat(data))
                                        }
                                    }}  
                                    onBlur={(data: any, error: any) => {
                                        data = parseFloat(data);
                                        if(data < 0) {
                                            error(true);
                                        }
                                    }}></ValueInput>

                            </Col>
                        
                            <Col xs={6}>
                                <Form.Label>Site 2 additional loss</Form.Label>
                                <ValueInput valueType="float" value={link.losses_site2 != null ? link.losses_site2 : 0}
                                    onChange={(data: any) => {
                                        data = parseFloat(data);
                                        if(!Number.isNaN(data)) {
                                            link.define("losses_site2", parseFloat(data))
                                        }
                                    }}  
                                    onBlur={(data: any, error: any) => {
                                        data = parseFloat(data);
                                        if(data < 0) {
                                            error(true);
                                        }
                                    }}></ValueInput>

                            </Col>

                        </Row>
                    )}
                    </SingleBandLinkUserContext.Consumer>
                :
                    <DualBandLinkUserContext.Consumer>
                        {(link) => (
                            <>
                                <Col>
                                    <Form.Label>Site 1 additional loss</Form.Label>
                                    <ValueInput valueType="float" value={link.losses_site1 != null ? link.losses_site1 : 0}
                                        onChange={(data: any) => {
                                            data = parseFloat(data);
                                            if(!Number.isNaN(data)) {
                                                link.define("losses_site1", parseFloat(data))
                                            }
                                        }}  
                                        onBlur={(data: any, error: any) => {
                                            data = parseFloat(data);
                                            if(data <= 0) {
                                                error(true);
                                            }
                                        }}></ValueInput>

                                </Col>
                                <Col xs lg="1" className="d-none d-xl-flex"></Col>
                                <Col>
                                <Form.Label>Site 2 additional loss</Form.Label>
                                <ValueInput valueType="float" value={link.losses_site2 != null ? link.losses_site2 : 0}
                                    onChange={(data: any) => {
                                        data = parseFloat(data);
                                        if(!Number.isNaN(data)) {
                                            link.define("losses_site2", parseFloat(data))
                                        }
                                    }}  
                                    onBlur={(data: any, error: any) => {
                                        data = parseFloat(data);
                                        if(data <= 0) {
                                            error(true);
                                        }
                                    }}></ValueInput>
                                </Col>

                            </>
                        )}
                    </DualBandLinkUserContext.Consumer>
                }
            </>
        );
    }

}
